<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-card>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </b-card>
    </template>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title v-if="enabledSearch">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="labelSearch"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="index"
            class="elevation-1"
          >
            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteEsusPecGlobal />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>

            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <b-button @click="emitAction(item)" style="color: #fff"
                >Detalhar</b-button
              >
            </template>
            <template v-slot:item.dt_nascimento="{ item }">
              <td>{{ formatDate(item.dt_nascimento) }}</td>
            </template>
            <template v-slot:item.dt_atendimento="{ item }">
              <td>{{ formatDate(item.dt_atendimento) }}</td>
            </template>
            <template v-slot:item.dt_procedimento="{ item }">
              <td>{{ formatDate(item.dt_procedimento) }}</td>
            </template>

            <template v-slot:item.nu_cns="{ item }">
              <td>
                <a
                  v-bind:href="`https://esusfeedback.com.br/api/imprimirCNS.php?nu_cns=${item.nu_cns}&co_ibge=${codIbge}`"
                  target="_blank"
                >
                  {{ item.nu_cns }}
                </a>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </b-skeleton-wrapper>
</template>

<script>
import utils from '@/mixins/utils.js'
export default {
  name: 'Tabela',
  mixins: [utils],
  props: {
    headers: {
      type: Array,
      default: () => {},
    },
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    enabledSearch: {
      type: Boolean,
      default: false,
    },
    labelSearch: {
      type: String,
      default: '',
    },
    codIbge: {
      type: String,
      default: '',
    },
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
        action: {},
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      search: '',
    }
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
    emitAction(item) {
      this.$emit('detalhar-cidadao', item)
    },
  },
}
</script>

<style></style>
